import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { TipoReporteGuiasEnviadasRecibidas } from "app/features/selectores/index";
import { TipoReporte } from "app/models/requireme";

type Entity = models.ParamsDiarioVenta;
export interface State {
    value: Entity;
}

/**
* Componente para editar un Entity
*/
export class ReporteDiarioVenta extends React.PureComponent<{}, State> {
    constructor(props) {
        super(props);
        this.state = {
            value: {} as Entity
        };
    }

    errors = () => validation.getErrors(this.rules, this.state.value);
    getField = formfields(() => ({
        value: this.state.value,
        onChange: (x: Entity) => this.setState({ value: x })
    }), this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            fechaDesde: validation.required,
            fechaHasta: validation.required,
            tipoReporte: validation.required
        };
    }

    onGenerar = async () => {
        var reporte = await resources.RepDiarioVentas.Generar(this.state.value);
        var tipoReporte = this.state.value.tipoReporte == TipoReporte.GuiasEnviadas ? "Guías enviadas": "Guías recibidas";
        var nombreReporte = "Reporte diario de venta -"+tipoReporte+"-.xls";
        kea.download(kea.base64ToBlob(reporte, 'application/vnd.ms-excel'), nombreReporte);
    }

    render() {
        const getField = this.getField;

        const DateTime = getField(kea.DateTime);
        const Tipo = getField(TipoReporteGuiasEnviadasRecibidas);

        return (
            <div>
                <kea.Title titulo="Reporte diario venta" onRegresar={() => history.go("../")} />
                {kea.autogrid(6, [
                    <DateTime field="fechaDesde" label="Fecha desde" />,
                    <DateTime field="fechaHasta" label="Fecha hasta" />,
                    <Tipo field="tipoReporte" label="Tipo de reporte" />,
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.Button children="Generar reporte" style="success" onClick={this.onGenerar} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reportediarioventa/index.tsx